// import store from '../store'
export const entityType = {
	center: 0,
	doctor: 1,
	pharmacy: 2,
}

export const dailyReportClassification = {
	important: 0,
	complaint: 1,
	normalNote: 2,
}

export const paymentMethod = {
	cash: 1,
	credit: 2,
	debit: 3,
}

// Permission IDs from /users/getself
export const visitPermission = {
	marketing: 34,
	scientific: 35,
}

// Named permissions for feature restrictions
export const permissionNames = {
	MarketingVisits: 34,
	ScientificVisits: 35,
}

// rolePermissions values
export const rolePermission = {
	undefined: 0,
	read: 1,
	action: 2,
}

// AccountsType على الـ API - نوع الحساب في حركات المواد
export const accountsType = {
	staff: 0,
	customers: 1,
	warehouse: 2,
	external: 3
}

export const sectionType = {
	staff: 1,
	customers: 2,
	materials: 3,
	visits: 4
	// customerTypeOne: store.state.configurations.customersTypesConf ? store.state.configurations.customersTypesConf.length : null
}

export const loyalty = [
	{
		id: 0,
		name: 'High'
	},
	{
		id: 1,
		name: 'Moderate'
	},
	{
		id: 2,
		name: 'Low'
	}
]

export const religions = [
	{
		id: 0,
		name: 'Muslim'
	},
	{
		id: 1,
		name: 'Christian'
	},
	{
		id: 2,
		name: 'Armenian'
	},
	{
		id: 3,
		name: 'Other'
	}
]

export const personalityArray = [
	{
		id: 0,
		name: 'C' 
	},
	{
		id: 1,
		name: 'D' 
	},
	{
		id: 2,
		name: 'I'
	},
	{
		id: 3,
		name: 'S'
	},
	{
		id: 4,
		name: 'Other'
	}
]

export const permissionsNamesEnum = {
	DebtSale: 31
}

// settlement state of a debt visit, computed server-side from its lines vs. what has been paid
export const debtPaymentStatus = {
	unpaid: 0,
	partiallyPaid: 1,
	paid: 2,
}

// localStorage keys
export const LOCAL_DATA_NAME = {
	FCM_DEVICE_TOKEN: 'fcmDeviceToken',
}

// mirrors OctoPharmaSystem's TransactionState — sent as materialAmounts[].state, the reason
// picked in the مرتجع (Return) tab in AddVisitDetails.vue
export const transactionState = {
	ravages: 1,
	stocktaking: 2,
	undefined: 0,
}

export const tempTransactionStatus = {
	pending: 1,
	accepted: 2,
	rejected: 3,
}

// mirrors OctoPharmaSystem.Communication.Notification.Models.NotificationType on the backend
export const notificationType = {
	visits: 1,
	plan: 2,
	materialPlan: 3,
	vacations: 4,
	dayOff: 5,
	materialTransaction: 6,
	other: 7,
}

// FCM push data payloads are string-only, and the backend sends the enum as its name
// (e.g. "MaterialTransaction") there instead of its numeric value like the REST API does —
// this normalizes either form back to the numeric value used throughout the app
export function resolveNotificationType(rawType) {
	if (rawType == null) return null
	const numeric = Number(rawType)
	if (!Number.isNaN(numeric)) return numeric
	const match = Object.entries(notificationType).find(([key]) => key.toLowerCase() === String(rawType).toLowerCase())
	return match ? match[1] : null
}